import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 0,
    "@media (min-width: 1200px)": {
      maxWidth: "none",
    },
  },
  count: {
    color: theme.palette.Other.titleText,
    fontWeight: 700,
    textAlign: "center",
    paddingTop: theme.spacing(5),
  },
  card: {
    padding: theme.spacing(5),
    "& .MuiPaper-root-MuiCard-root": {
      borderRadius: 8,
      boxShadow: "5px 5px 5px 5px rgba(0, 0, 0, 0.3)",
    },
    "& .MuiCardContent-root:last-child": {
      padding: "theme.spacing(5) !important",
    },
  },
  userOverViewCard: {
    textAlign: "center",
    padding: 20,
    background: "white",
  },
  customerOverViewCard: {
    padding: 20,
    background: "white",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
  },
  customerSub: {
    paddingTop: "15px",
    display: "flex",
    justifyContent: "space-around",
  },
  mainCard: {
    width: 351,
    height: 110,
  },
  subCardUser: {
    width: 200,
    height: 95,
  },
  subCardSubscription: {
    width: 230,
    height: 100,
    border: "1px solid",
  },
  tableContainer: {
    padding: 0,
    width: "100%",
    "@media (min-width: 1200px)": {
      maxWidth: "none",
    },
  },
  customerSubLower: {
    padding: "25px 35px",
    display: "flex",
    justifyContent: "space-around",
  },
  tableContainerCero: {
    overflow: "auto",
    position: "relative",
    width: "100%",
    maxWidth: "none",
  },
  table: {
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: "#D0C5CA",
    fontWeight: "bold",
    border: "1px solid #5A404E80",
    textAlign: "left",
    position: "sticky",
    top: 0,
    zIndex: 5,
  },
  tableCell: {
    border: "1px solid #5A404E80",
    textAlign: "left",
    margin: "auto",
  },
  searchBox: {
    borderRadius: "8px",
    width: "220px",
    height: "55px",
  },
  inputBox: {
    backgroundColor: "#fff",
  },
  inactive: {
    color: theme.palette.status.added,
  },
  active: {
    color: "#48742C",
  },
  lock: {
    color: theme.palette.status.review,
  },
  disabled: {
    color: theme.palette.status.pendingApproval,
  },
  readOnlyMode: {
    color: theme.palette.status.audited,
  },
  signalVerified: {
    backgroundColor: theme.palette.status.verified,
    width: 16,
    height: 16,
    borderRadius: "50%",
    border: "1px solid black",
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
